const getTestDriveDataToSubmit = (date: string, time: string) => {
  const appointmentData = {
    appointmentId: 'Appointment1', // Hardcoded
    appointmentName: 'Test Drive', // Hardcoded
    appointmentLocation: 'Dealer', // Hardcoded
    appointmentDate: date,
    appointmentTime: '',
    preferredTimeOfDay: time,
  };
  return [appointmentData];
};

export default getTestDriveDataToSubmit;
